import { render, staticRenderFns } from "./FormBody.vue?vue&type=template&id=b4f56d38&scoped=true"
import script from "./FormBody.vue?vue&type=script&lang=js"
export * from "./FormBody.vue?vue&type=script&lang=js"
import style0 from "./FormBody.vue?vue&type=style&index=0&id=b4f56d38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f56d38",
  null
  
)

export default component.exports